import type { MouseEvent } from "react"

export const opensElsewhere = (event: MouseEvent): boolean => event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0
